'use client';
import { useUserContext } from '@nrdy-marketing-engine/server/src/user/context';
import { useEffect, useState } from 'react';
import { trackCartFailure } from '../../lib/track-service/track-cart';

function useCheckoutUserMetrics() {
  const { user, loading: userLoading } = useUserContext();
  // Tracking state is use to prevent multiple tracking calls due to re-renders
  const [tracking, setTracking] = useState(false);
  useEffect(() => {
    if (userLoading) return;
    if (!user) return;
    async function trackUserMetrics() {
      await trackCartFailure(
        'checkout_invalid_user',
        {
          clientUuid: user?.entity?.client_uuid,
        },
        user
      );
    }
    if (!user?.entity?.client_uuid && !tracking) {
      trackUserMetrics();
      setTracking(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, userLoading]);
}

export default useCheckoutUserMetrics;
